module.exports = __webpack_public_path__ + "static/colorblindness-f53a3b74be9179dbee7a04b4f058033f.png";